import React, { useEffect, useRef } from "react";

export default function ScrollText({ text }) {
  const textRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const el = textRef.current;
      if (!el) return;

      const rect = el.getBoundingClientRect();
      const letters = el.querySelectorAll(".letter");
      const windowHeight = window.innerHeight;

      const progress = (windowHeight - rect.top) / (windowHeight * 0.9);
      const visibleLetters = Math.floor(progress * letters.length);

      letters.forEach((span, index) => {
        span.style.color = index < visibleLetters ? "#000000" : "#cccccc";
      });
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // run once on load

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="main-heading" ref={textRef}>
      {text.split("").map((char, index) => (
        <span key={index} className="letter">
          {char}
        </span>
      ))}
    </div>
  );
}